import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={30}
            height={30}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <rect x={0.5} y={0.5} width={29} height={29} rx={14.5} fill="#fff" />
        <rect x={0.5} y={0.5} width={29} height={29} rx={14.5} stroke={theme["#0EA59D"]} />
        <path
            d="M15 15a4.167 4.167 0 100-8.333A4.167 4.167 0 0015 15zM15 17.084c-4.174 0-7.574 2.8-7.574 6.25 0 .233.183.416.416.416H22.16a.413.413 0 00.417-.416c0-3.45-3.4-6.25-7.575-6.25z"
            fill={theme["#0D968F"]}
        />
        </svg>
    )
}
  
  export default SvgComponent